import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-down\"><path d=\"M884.0192 256H808.96c-5.12 0-9.9328 2.5088-12.9024 6.6048L512 654.1824 227.8912 262.656A16.0768 16.0768 0 0 0 215.04 256H139.9808a8.0384 8.0384 0 0 0-6.5024 12.6976l352.6144 486.0928a31.8976 31.8976 0 0 0 51.712 0l352.6144-486.0928A7.9872 7.9872 0 0 0 884.0192 256z\" fill=\"\" p-id=\"3844\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol